const basicArrayMapper =
  (dataArray = []) =>
  (mapper: any) =>
    dataArray.reduce(mapper, []);

export default basicArrayMapper;
